module.exports = __webpack_public_path__ + "img/tj.b9695fb3.jpg";